import React from 'react';
import SEO from '../components/SEO';
import Hero from '../components/Hero';
import StatsCard from '../components/StatsCard';
import WhyRussia from '../components/WhyRussia';
import TopUniversities from '../components/TopUniversities';
import PartnerLogos from '../components/PartnerLogos';
import Counsellors from '../components/Counsellors';
import Alumni from '../components/Alumni';
import Testimonials from '../components/Testimonials';
import TrustedVoices from '../components/TrustedVoices';
import CTA from '../components/CTA';
import FAQ from '../components/FAQ';

export default function Home() {
  return (
    <>
      <SEO
        title="Russian Education — MBBS in Russia | Direct Admission in NMC-Approved Universities"
        description="Direct MBBS admission in 64 NMC-approved Russian medical universities. WHO-recognised degree, 100% English medium, affordable fees (₹25L for 6 years), zero donation. Free counselling: +91 95094 06802."
        path="/"
        keywords="MBBS in Russia, MBBS abroad, NMC approved universities Russia, MBBS in Russia fees, study MBBS in Russia, WHO recognised medical universities, Indian students MBBS Russia"
      />
      <Hero />
      <StatsCard />
      <WhyRussia />
      <TopUniversities />
      <PartnerLogos />
      <Counsellors />
      <Alumni />
      <Testimonials />
      <TrustedVoices />
      <CTA />
      <FAQ />
    </>
  );
}
